import React, { useEffect } from 'react';
import styles from './M_ContextMenu.module.css';
import { useTranslation } from '@/hooks/useTranslation';
import A_ContextMenuItem from '@/components/A_Atoms/A_ContextMenuItem/A_ContextMenuItem';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import cn from 'classnames';

interface M_ContextMenuProps {
  isOpen: boolean;
  onClose: () => void;
  shareUrl: string;
  showDelete?: boolean;
  onDelete?: () => void;
  anchorRef: React.RefObject<HTMLDivElement | null>;
}

export default function M_ContextMenu({
  isOpen,
  onClose,
  shareUrl,
  showDelete = false,
  onDelete,
  anchorRef,
}: M_ContextMenuProps) {
  const t = useTranslation();

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (anchorRef.current && !anchorRef.current.contains(e.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onClose, anchorRef]);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
    } catch {
      // fallback or ignore
    }
    onClose();
  };

  const handleDelete = () => {
    onDelete?.();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className={cn(styles.wrapper, 'effect-button-glow')} role='menu'>
      <A_ContextMenuItem
        onClick={handleCopyLink}
        icon={<Q_Icon.CopyIcon width={20} height={20} fill='none' />}
      >
        {t('capsulePostActions.copyLink')}
      </A_ContextMenuItem>
      {showDelete && onDelete && (
        <A_ContextMenuItem
          onClick={handleDelete}
          danger
          icon={<Q_Icon.DeleteIcon width={20} height={20} fill='none' />}
        >
          {t('capsulePostActions.delete')}
        </A_ContextMenuItem>
      )}
    </div>
  );
}
